import { useEffect, useState } from "react"

function getMatches(query: string): boolean {
    return typeof window !== "undefined" && typeof window.matchMedia === "function" ? window.matchMedia(query).matches : false
}

export function useMediaQuery(query: string): boolean {
    const [matches, setMatches] = useState(() => getMatches(query))

    useEffect(() => {
        if (typeof window === "undefined" || typeof window.matchMedia !== "function") return

        const mediaQuery = window.matchMedia(query)
        const onChange = (event: MediaQueryListEvent) => setMatches(event.matches)
        setMatches(mediaQuery.matches)
        mediaQuery.addEventListener("change", onChange)
        return () => mediaQuery.removeEventListener("change", onChange)
    }, [query])

    return matches
}
